import { Confirmation } from './confirmation';

import { rand, randNumber } from '@ngneat/falso';

export class MockConfirmation extends Confirmation {
   constructor() {
      super({
         decision: rand([ 'ACCEPT', 'CANCEL', 'DECLINE', 'REVIEW' ]),
         ref: randNumber({ min: 100000, max: 999999 }).toString()
      });
   }
}
